import(/* webpackMode: "eager", webpackExports: ["Providers"] */ "/vercel/path0/app/providers.tsx");
;
import(/* webpackMode: "eager" */ "/vercel/path0/styles/globals.css");
;
import(/* webpackMode: "eager" */ "/vercel/path0/node_modules/.pnpm/@reach+tabs@0.12.1_react-dom@19.1.1_react@19.1.1__react@19.1.1/node_modules/@reach/tabs/styles.css");
